import { Routes } from '@angular/router';
import { AuthGuard } from '../../services/guards/auth.guard';
import { AvtalePage } from './avtaler.page';

export const routes: Routes = [
  {
    path: '',
    component: AvtalePage,
    canActivate: [AuthGuard]
  }
];
